import {getOperatorLabel} from './getOperatorLabel';

/**
 * Returns true if the operator selector should be visible or not
 *      - false if there is no field selected yet
 *      - false if selected field has no operators setup
 *      - false if field only has one operator and the label is set to 'null'
 *      - true in all the other cases
 *
 * TODO: write tests
 *
 * @param {object} field Field setup
 * @returns boolean
 */
export function isOperatorSelectorVisible(field) {
    if (!field) return false;
    if (!field.operators.length) return false;
    if (field.operators.length == 1 && !getOperatorLabel(field.operators[0])) return false;

    return true;
}
